import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Krijo", href: "#why-krijo" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled || open ? "nav-scrolled" : "bg-transparent"}`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src="/krijo-logo.png" alt="Krijo Consultancy Services logo" className="h-11 w-11 rounded-lg object-cover" />
          <span className="font-['Poppins'] font-semibold text-lg leading-tight">
            Krijo
            <span className="block text-[10px] font-medium tracking-[0.25em] text-[#F89335] uppercase">Consultancy Services</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-slate-300 hover:text-[#F89335] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-book-consultation-button"
            className="btn-primary-glow font-['Poppins'] font-semibold text-sm px-6 py-2.5 rounded-full"
          >
            Book Consultation
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden nav-scrolled px-6 pb-6 pt-2 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-base font-medium text-slate-200 hover:text-[#F89335] transition-colors"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-mobile-book-consultation-button"
            className="btn-primary-glow font-['Poppins'] font-semibold text-sm px-6 py-3 rounded-full text-center mt-2"
            onClick={() => setOpen(false)}
          >
            Book Consultation
          </a>
        </div>
      )}
    </header>
  );
}
